type ChartValueTooltipProps = {
  label: string;
  value: string;
};

export function ChartValueTooltip({ label, value }: ChartValueTooltipProps) {
  return (
    <div className="rounded-lg border border-border/primary bg-background/primary px-3 py-2 text-xs shadow-md space-y-0.5">
      <p className="body-small-medium">{label}</p>
      <p className="body-small-regular text-text/secondary">{value}</p>
    </div>
  );
}
